import React, {useEffect, useContext, useState} from 'react'
import {Button, Card, Col, message, Row} from "antd";
import PurchaseInfos from "../create/PurchaseInfos";
import PurchaseCompleteTable from "./PurchaseCompleteTable";
import {getAllRecipes} from "../../../services/serviceRecipe";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {getPurchaseById, closePurchase} from "../../../services/servicePurchase";
import {useParams} from "@reach/router";
import {getAllSupplier} from "../../../services/serviceSupplier";
import PurchaseMidTotal from "../table-components/PurchaseMidTotal";
import {getAllTax} from "../../../services/serviceTax";
import PurchaseTaxTable from "../taxTable/PurchaseTaxTable";
import TaxTotal from "../taxTable/TaxTotal";
import {enterLoadingState, exitLoadingState} from "../../../utils/helpers/commonFunctions";



const PurchaseComplete = () => {
    const {purchaseId} = useParams()
    const {recipes, purchaseInfos, stocks, suppliers, purchaseItems, taxes} = useContext(PurchaseContext)
    const [purchaseList, setPurchaseList] = purchaseItems
    const [taxList, setTaxList] = taxes
    const [, setRecipeData] = recipes
    const [, setStockList] = stocks
    const [, setSupplierList] = suppliers
    const [purchaseInformations, setPurchaseInformations] = purchaseInfos
    const [loadings, setLoadings] = useState([])
    const [selectedRecipes, setSelectedRecipes] = useState([])

    useEffect(() => {
        getAllRecipes()
            .then(({data}) => setRecipeData(data))
    }, [])

    useEffect(() => {
        getAllSupplier()
            .then(({data}) => setSupplierList(data))
    }, [])

    useEffect(() => {
        getPurchaseById(purchaseId)
            .then(({data}) => setContext(data))
    }, [])

    useEffect(() => {
        getAllTax()
            .then(({data}) => reduceTaxData(data))
    }, [])

    const reduceTaxData = (data) => {
        const taxList = data.map((item, index) => ({key: index, taxId: item.id, taxName:item.name, taxRatio:item.ratio}))
        setTaxList(taxList)
    }

    const handleRecipeSelection = (val) => {
        setSelectedRecipes(() => val.map(i => {
            return {
                id: i.key
            }
        }))
    }

    const setContext = (data) => {
        if (data.contentOfPurchaseList) {
            const stockData = data.contentOfPurchaseList.map((item) => {
                return {
                    text: `${item.stock.code || ''} - ${item.stock.name || ''}`,
                    value: item.stock.id,
                    code: item.stock.code,
                    currency: item.stock.currency,
                    description: item.stock.description || '',
                    id: item.stock.id,
                    contentId: item.id,
                    name: item.stock.name || '',
                    price: item.stock.price,
                    quantity: item.stock.quantity,
                    recipe: item.stock.recipe || null,
                    unit: item.stock.unit || ''
                }
            })
            setStockList(stockData)
        }

        const purchaseList = data.contentOfPurchaseList.map((item, index) => {
            return {
                key: index,
                stock: item.stock.id,
                unit: item.unit,
                selectedCurrency: item.stock.currency,
                unitPrice: item.stock.price,
                shippingDate: item.shippingDate,
                quantity: `${item.quantity}`
            }
        })
        setPurchaseList(purchaseList)

        const purchaseInfo = {
            whom: data.whom,
            payment: data.payment,
            exchangeRate: data.exchangeRate,
            delivery: data.delivery,
            purchaseNumber: data.purchaseNumber,
            purchaseStatus: data.purchaseStatus
        }
        setPurchaseInformations(purchaseInfo)
    }

    const supplierValidation = (list) => list.every(item => item.supplier)

    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        if (!supplierValidation(purchaseList)) {
            exitLoadingState(setLoadings)
            return message.warn('Bütün Tedarikçi Alanlarını Doldurunuz')
        } else {
            const contentOfPurchaseList = purchaseList.map(item => {
                let total = item.quantity * (item.unitPrice || 0)
                if (item.discount) total -= total * item.discount / 100
                return {
                    shippingDate: item.shippingDate,
                    stock: {
                        id: item.stock,
                    },
                    id: item.contentId,
                    selectedCurrency: item.selectedCurrency,
                    quantity: item.quantity,
                    unit: item.unit,
                    linePrice: item.unitPrice,
                    discount: item.discount,
                    supplier: item.supplier ? {id: item.supplier} : null,
                    lineTotal: total
                }
            })

            const purchaseTaxCosts = taxList.map(item => {
                return {
                    costName: item.taxName,
                    ratio: item.taxRatio
                }
            })

            const requestInfo = {
                purchase: {
                    completedPurchase: true,
                    contentOfPurchaseList: contentOfPurchaseList || [],
                    id: purchaseId,
                    purchaseNumber: purchaseInformations.purchaseNumber,
                    rejectionReason: '',
                    totalPrice: 0,
                    purchaseStatus: purchaseInformations.purchaseStatus,
                    delivery: purchaseInformations.delivery || '',
                    payment: purchaseInformations.payment || '',
                    whom: purchaseInformations.whom || '',
                    exchangeRate: purchaseInformations.exchangeRate || '',
                    recipe: selectedRecipes.length ? selectedRecipes : null
                },
                purchaseTaxCosts: purchaseTaxCosts
            }

            closePurchase(requestInfo)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setTimeout(() => window.history.back(), 500)
                })
                .catch(() => exitLoadingState(setLoadings))
        }
    }

    return(
        <React.Fragment>
            <Card
                title={'Satın Alma Tamamla'}
                extra={<Button type={'primary'} loading={loadings[0]} onClick={handleSubmit}>Tamamla</Button>}
            >
                <PurchaseInfos isComplete={true} handleRecipeSelection={handleRecipeSelection}/>
                <Row justify={'start'}>
                    <Col span={12}>
                        <h4>Satın Alma Listesi</h4>
                    </Col>
                </Row>
                <PurchaseCompleteTable />
                <PurchaseMidTotal />
                <PurchaseTaxTable />
                <TaxTotal />
            </Card>
        </React.Fragment>
    )
}
export default PurchaseComplete